export const WAISTCOAT_GEOMETRY_V1 = 'waistcoat_geom_v1';
export const WAISTCOAT_ACTIVE_GEOMETRY_VERSION = WAISTCOAT_GEOMETRY_V1;
